import { Logger } from '@/classes/Logger';
import { AppSettingsService } from '@/services/AppSettingsService';
import { AppSettingsModel, StickySettingsActions, StickySettingsFields, StickySettingsGetters, StickyStoreNames } from '@/types';
import { mapGetters, mapActions } from 'vuex';

export const AppSettingsHelper = {
  computed: {
    ...mapGetters(StickyStoreNames.AppSettings, [StickySettingsGetters.GetStickyStateField]),
    paginationOptions(this: any) {
      return this.appSettings.paginationOptions;
    },
    backgroundExportOptions(this: any) {
      return this.appSettings.backgroundExportOptions;
    },
    appSettings(this: any) {
      return this.getStickyStateField(StickySettingsFields.AppSettings);
    }
  },
  methods: {
    ...mapActions(StickyStoreNames.AppSettings, [StickySettingsActions.SetStickyStateField])
  },
  created(this: any) {
    if (!this.appsettings) {
      AppSettingsService.getAppSettingsAsync()
        .then((response: AppSettingsModel) => {
          this.setStickyStateField({ field: StickySettingsFields.AppSettings, value: response });
        })
        .catch((error: any) => {
          Logger.$log(error);
        });
    }
  }
};
